import React from "react";
import { PrismicRichText } from "@prismicio/react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Container, Row, Col } from "react-bootstrap";

import "../../styles/components/slices/simple_section.scss";

const SimpleSection = ({ slice }) => {
  if (!slice) return null;

  return (
    <Container
      fluid
      style={
        slice.primary.background_color
          ? {
              backgroundColor: `${slice.primary.background_color}`,
            }
          : {}
      }
    >
      <Container className="simple-section max-container">
        <Row className="w-100 justify-content-center">
          {slice.primary.image?.gatsbyImageData && (
            <Col md={8} className="align-self-center text-center">
              <GatsbyImage
                image={slice.primary.image.gatsbyImageData}
                alt={slice.primary.image.alt || "image"}
                className="mb-5"
              />
            </Col>
          )}

          <Col xs={11} md={8} className="align-self-center">
            <div
              className={`descr ${slice.primary.custom_style ? "mb-5" : ""}`}
            >
              <PrismicRichText field={slice.primary.text.richText} />
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default SimpleSection;
